export enum FiscalIdKind {
    CfPersonaFisica = 'CfPersonaFisica',
    CfPersonaGiuridica = 'CfPersonaGiuridica',
    PartitaIva = 'PartitaIva'
}

export interface FiscalId {
    id: number,
    description: string,
    value: string,
    isPreferred: boolean,
    kind: FiscalIdKind
}